import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThread: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconThread"><Path d="M11.9688 1.5C12.8555 1.5 13.5954 2.14783 13.7286 3H20V4.5H19V9.86393L5 7.53125V4.5H4V3H10.2089C10.3421 2.14783 11.082 1.5 11.9688 1.5Z" fill="currentColor"/><Path d="M5 9.05176L19 11.3844V14.8638L5 12.5311V9.05176Z" fill="currentColor"/><Path d="M5 14.0518V19.4998H4V20.9998H10.2052C10.3265 21.8479 11.0559 22.4998 11.9375 22.4998H12C12.8816 22.4998 13.611 21.8479 13.7323 20.9998H20V19.4998H19V16.3844L5 14.0518Z" fill="currentColor"/></CentralIconBase>;
});

export default IconThread;
